import moment from 'moment';
import {
  TIMETABLE_TIMESLOT_CONFIGURATION,
  timetable_timeslot_configurationQuery,
  timetable_timeslot_configurationQueryVariables,
} from '@app-types/graphql-types';
import { ApolloQueryResult } from '@apollo/client';
import { apolloClient } from '@lib/apollo';
import { GetTimeSlotConfigurationDataForCurrentWeekArgs } from '../../types';

export const getTimeSlotConfigurationDataForCurrentWeek = ({
  week,
  batchId,
}: GetTimeSlotConfigurationDataForCurrentWeekArgs): Promise<
  ApolloQueryResult<timetable_timeslot_configurationQuery>
> => {
  return apolloClient.query<timetable_timeslot_configurationQuery, timetable_timeslot_configurationQueryVariables>({
    query: TIMETABLE_TIMESLOT_CONFIGURATION,
    variables: {
      where: {
        batchId: {
          _eq: batchId,
        },
        startTime: {
          _gte: moment().year(week.year()).week(week.week()).startOf('isoWeek'),
          _lte: moment().year(week.year()).week(week.week()).endOf('isoWeek'),
        },
        default: {
          _eq: false,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });
};
